{
  "029ef6f4f0667bd9": "No se pudo enviar la invitación. Por favor, inténtalo de nuevo.",
  "0424c75bd89ccd79": "Gestión de Rotación",
  "05c79b2de04cd81a": "Fecha límite de deserción",
  "0710b88de3abd3ff": "Horas trabajadas",
  "07548c2c6511d4d1": "Expandir",
  "07a2d579c3f0d325": "Favoritos",
  "0b4243f09a2f1e18": "Próxima turno",
  "0ee285fd8fb204b1": "Pronto ({{minDays}}-{{maxDays}}d)",
  "1016c07b0f58d365": "Alternar visibilidad de la contraseña",
  "10995167701b917f": "Primer turno",
  "12d4885ac31f81d2": "Ver perfil del trabajador",
  "143d7c5951940e20": "Invitó a {{workerName}} a la visita.",
  "16f5c76194abea44": "Error al actualizar las credenciales del trabajador.",
  "18f2a0947f9d6523": "Bloqueado",
  "18fdd549b2ed367a": "Nuevo",
  "19766ed6ccb2f4a3": "Cancelar",
  "199a694d51e3e238": "No se encontraron registros de DNR",
  "19c73a5cdf346d96": "Profesional",
  "1c8ac867f052ea4a": "Visita",
  "1ebe33a7ca0e9b6a": "Ocurrió un error al cargar el número de la persona",
  "1f39af20f9f76f6f": "con preguntas.",
  "1fd9ae1607aa3d80": "Invitar",
  "22b8701f928b506a": "Todos los tipos de licencia",
  "24994239b28b5d66": "Este profesional ha sido bloqueado de su lugar de trabajo.",
  "257c8051763d5f71": "Compartir credenciales",
  "29382cedf177bab3": "No se pudieron cargar los profesionales. Por favor, inténtalo de nuevo.",
  "2e71da3a95d291bc": "Buscar un profesional",
  "31e392d1c0378bec": "Aplicar",
  "322d4240e1f506a4": "Contraseña de charting",
  "34b09cd6a31d5c6b": "Cargando casos...",
  "35b50b5750239f6d": "No hay profesionales próximos",
  "35e2d9bb75fa0910": "{{count}} días restantes",
  "36931a940259dfe1": "Bloqueado por",
  "37a4c617eaf23768": "No hay profesionales que coincidan con este filtro.",
  "433edf86242299ad": "Software de charting",
  "44b23f3add41fbac": "Profesional destacado",
  "460b3a7da007b7af": "Chat",
  "4b989bb982644a34": "Cerrar turnos reservados",
  "4bd715c382a8f125": "Compartir credenciales en masa",
  "4c99602501042e23": "Última visita de",
  "4d0dccebdf232cdf": "En tu lugar de trabajo",
  "4d8548279e5ec890": "Solo lista, NO es un trabajador de Clipboard: NO CONTACTAR. Mensaje",
  "4e9682fa850ed767": "hrs",
  "546ebb8eb993ea56": "Filtros",
  "56bfed64111593cd": "No hay profesionales aún",
  "56cdd09bb76b92df": "Filtrar riesgos de rotación",
  "58ffa3984521da53": "Profesionales Próximos",
  "594d6f25059d8281": "No se pudieron cargar los casos.",
  "5a6622b6c936e060": "Editar credenciales",
  "5f1a2542e4e4ca5e": "Próximo",
  "5fbd94fab10dd609": "Último turno",
  "6497caa0b3ed4629": "Destacar profesional",
  "663ea1bfffe5038f": "a",
  "6b7c6c52597851ea": "Profesional bloqueado",
  "6c328e4982bfaf41": "No hay profesionales pasados",
  "6da1b79e34feeb7f": "Más tarde ({{minDays}}-{{maxDays}}d)",
  "6e6efd60da4a33c3": "Registrar entrada/salida",
  "6f1e379f2503a270": "Credenciales actualizadas con éxito",
  "6fba4e15a1cbf99d": "Las credenciales fueron actualizadas, pero la contraseña predeterminada del lugar de trabajo no pudo ser guardada. Por favor, inténtalo de nuevo.",
  "708e415f9ac11beb": "Mis Profesionales",
  "712da63171e0c9de": "Desbloquear",
  "72ed245d2cf11822": "Razones",
  "72f256afd196ceae": "Tipo de licencia",
  "771fec220e68bb00": "Este profesional no tiene turnos próximos.",
  "79d05966d82ae951": "Fecha de bloqueo",
  "856e3761c64cb75a": "Error al compartir credenciales, por favor intenta de nuevo.",
  "8662c0452eadf09c": "No hay profesionales en riesgo de deserción.",
  "878bdbf15dccac2e": "{{count}} días restantes",
  "898e26e85b0af7fb": "Última visita a",
  "8a7525b1492fb848": "Notas",
  "9366db524dd21853": "Filtrar profesionales anteriores",
  "937d7af2b0a4d271": "nombre tmz",
  "942087cc2d41e013": "Reintentar",
  "943318c70926fdae": "No hay visitas abiertas disponibles para invitar a {{workerName}}.",
  "981038b9aea98b69": "Invitar personal",
  "9b18491d601d3708": "Lugar de trabajo actual",
  "9efd44c8a075af86": "Quitar destacado profesional",
  "9fb0aedc4603d8ac": "Profesional aún no integrado",
  "a52ace420f2175d0": "Todos",
  "a593cc9212aba25d": "Todos los casos",
  "a64dd88e87280ca6": "Las credenciales fueron actualizadas, pero el ID externo no pudo ser guardado. Por favor, inténtalo de nuevo.",
  "a6a5fc451f8f8e92": "Los profesionales en su lista de DNR no pueden ser añadidos a su lista de destacados.",
  "b36d293309ceff16": "Mantenga esto alineado con el sistema del lugar de trabajo para que el profesional pueda comenzar sin problemas.",
  "b4e929d8bcfe0418": "Documentos",
  "b56317a404c818d8": "Ahora (≤{{maxDays}}d)",
  "b8ed5279e897be5d": "Enviando…",
  "baaa3007f92b4afd": "Abrir filtros",
  "bd40133d140c53ee": "Guardar como contraseña predeterminada del lugar de trabajo",
  "be6eb1fc3b05bf9d": "Colapsar",
  "bf5a7af358e1e492": "Última visita registrada",
  "bfd993fceff3d122": "Invitar al caso",
  "c06a54a00e88facc": "Próximo turno {{date}}",
  "c1ad5dcf2e0576ad": "Enviar Invitación",
  "c884fe234d8c8d70": "{{hours}} hrs",
  "c922464a23f03bfc": "Último turno trabajado",
  "c9b42f3a21a74161": "Total de visitas",
  "ca1530e8d7017547": "Pasado",
  "ca2025fdc8918fe6": "Este profesional no tiene turnos pasados.",
  "cc6ed3013b909ae3": "No se proporcionaron razones",
  "cd8c3f07cf2f3a40": "Filtrar profesionales próximos",
  "ce2b12db8242d7b9": "{{deadline}} · {{daysLeft}}",
  "d0a435de6fc4a493": "Ver documentos",
  "d1bf045bb524dae5": "Ver detalles",
  "d48a617c7da5163c": "Credenciales",
  "d694eaeed5f7e39d": "Una vez marcado, este profesional se destacará en flujos de invitación y chat cuando publiques nuevos turnos.",
  "daee7606b339f3c3": "Restablecer",
  "e81144088c20897e": "Último turno {{date}}",
  "ec73df6c916275b0": "Profesionales Pasados",
  "eceb255ef3b5061f": "Credenciales necesarias",
  "f10988e79e8d9a49": "Todos los tipos",
  "f12dee008fc34050": "Nombre de usuario de charting",
  "f3314dc78a3e0b64": "Turnos Reservados",
  "f412ebc3df40018a": "Guardar credenciales",
  "f71081fb0af48ae6": "Descanso",
  "f8d46c2570e70736": "Más acciones",
  "f9d37c23fcc0f03c": "urgente"
}
